export const PHONE = '1 (868) 765-1634';
export const PHONE_HREF = 'tel:+18687651634';
export const WHATSAPP_HREF = 'https://wa.me/18687651634';

// Social links — paste the real profile URLs in. Empty ones render as plain
// text instead of dead links.
export const SOCIALS = [
  { id: 'youtube', label: 'YouTube', url: 'https://www.youtube.com/@velocitylearningtt' },
  { id: 'instagram', label: 'Instagram', url: '' },
  { id: 'facebook', label: 'Facebook', url: '' },
];

// Apps Script Web App URL that writes signups to the Google Sheet.
// Deploy scripts/signup-endpoint.gs and paste the /exec URL here.
// While this is empty the sign-up card shows contact details instead.
export const SIGNUP_ENDPOINT =
  'https://script.google.com/macros/s/AKfycbwzOZYcSb-y72SQa9G1jjUPOgLgQgp9Ruku6xTQ3h55krBBKnXFhi1k3yYjbv8_siAO/exec';

// Netlify Function that forwards events to the Conversions API.
export const CAPI_ENDPOINT = '/.netlify/functions/meta-capi';
